import type { ListBuilderColumn } from '../../types';
import { VEHICLE_STATUS_VALUE_MAPPING } from './shared';

/**
 * Vehicle name column with link to vehicle page
 */
export const createVehicleNameColumn = (): ListBuilderColumn => ({
	id: 'vehicle-name',
	headers: [
		{
			id: 'vehicle-name-header',
			text: 'Vehicle Name',
		},
	],
	fields: [
		{
			id: 'name-field',
			dataConfig: {
				type: 'field',
				field: {
					fieldName: 'name',
					objectTable: 'vehicle',
				},
			},
			styleConfig: {
				size: 'md',
				colorRule: {
					type: 'default',
				},
			},
			displayStyle: 'text',
			link: {
				type: 'object',
				enabled: true,
			},
		},
		{
			id: 'line-break-1',
			dataConfig: {
				type: 'custom_text',
				customText: '',
			},
			displayStyle: 'line_break',
		},
		{
			id: 'type-field',
			dataConfig: {
				type: 'field',
				field: {
					fieldName: 'type',
					objectTable: 'vehicle',
				},
			},
			styleConfig: {
				size: 'sm',
				colorRule: {
					type: 'muted',
				},
			},
			displayStyle: 'text',
		},
	],
	sortable: true,
});

/**
 * License plate column
 */
export const createLicensePlateColumn = (): ListBuilderColumn => ({
	id: 'license-plate',
	headers: [
		{
			id: 'license-plate-header',
			text: 'License Plate',
		},
	],
	fields: [
		{
			id: 'license-plate-field',
			dataConfig: {
				type: 'field',
				field: {
					fieldName: 'licensePlate',
					objectTable: 'vehicle',
				},
			},
			styleConfig: {
				size: 'sm',
				colorRule: {
					type: 'default',
				},
			},
			displayStyle: 'text',
		},
	],
	sortable: true,
	width: 140,
});

/**
 * Status column with badge display
 */
export const createStatusColumn = (): ListBuilderColumn => ({
	id: 'status',
	headers: [
		{
			id: 'status-header',
			text: 'Status',
		},
	],
	fields: [
		{
			id: 'status-field',
			dataConfig: {
				type: 'field',
				field: {
					fieldName: 'status',
					objectTable: 'vehicle',
				},
			},
			styleConfig: {
				size: 'sm',
				valueMapping: [...VEHICLE_STATUS_VALUE_MAPPING],
			},
			displayStyle: 'badge',
		},
	],
	sortable: true,
	width: 130,
});

/**
 * Volume capacity column
 */
export const createVolumeCapacityColumn = (): ListBuilderColumn => ({
	id: 'volume-capacity',
	headers: [
		{
			id: 'volume-capacity-header',
			text: 'Volume Capacity',
		},
	],
	fields: [
		{
			id: 'volume-capacity-field',
			dataConfig: {
				type: 'field',
				field: {
					fieldName: 'volumeCapacity',
					objectTable: 'vehicle',
				},
			},
			styleConfig: {
				size: 'sm',
				colorRule: {
					type: 'default',
				},
			},
			displayStyle: 'text',
		},
	],
	sortable: true,
	width: 140,
});

/**
 * Assigned routes column
 */
export const createAssignedRoutesColumn = (): ListBuilderColumn => ({
	id: 'assigned-routes',
	headers: [
		{
			id: 'assigned-routes-header',
			text: 'Assigned Routes',
		},
	],
	fields: [
		{
			id: 'assigned-routes-field',
			dataConfig: {
				type: 'field',
				field: {
					fieldName: 'assignedRoutesCount',
					objectTable: 'vehicle',
				},
			},
			styleConfig: {
				size: 'sm',
				colorRule: {
					type: 'default',
				},
			},
			displayStyle: 'text',
		},
	],
	sortable: true,
	width: 140,
});

/**
 * Create all standard vehicle columns
 */
export const createVehicleColumns = (): Array<ListBuilderColumn> => [
	createVehicleNameColumn(),
	createLicensePlateColumn(),
	createStatusColumn(),
	createVolumeCapacityColumn(),
	createAssignedRoutesColumn(),
];
